module.exports = __webpack_public_path__ + "nicon-sort.svg";